import React from 'react'
import { Link } from 'react-router-dom'

import '../Home/Home.css'

export default class Estabelecimentos extends React.Component {

    render() {
        return (
            <div className="home">
                <Link to='/fichas'>
                    <div className="ficha pacientes col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-hospital-alt verdeUnimed icone"></i>
                        <b className="verdeUnimed">NOVO</b>
                    </div>
                </Link>

                <Link to='/'>
                    <div className="ficha protocolos col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-search verdeUnimed icone"></i>
                        <b className="verdeUnimed">BUSCAR</b>
                    </div>
                </Link>

                <Link to='/'>
                    <div className="ficha escalas col-md-12 col-lg-4 d-inline-block">
                        <i class="fas fa-map-marked-alt verdeUnimed icone"></i>
                        <b className="verdeUnimed">MAPA</b>
                    </div>
                </Link>
            </div>
        )
    }
}